import React, { useContext, useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import AuthContext from '../../contexts/AuthContext';

export default function EditUserRoleDialog({ open, onClose, organizationId, user, onUpdated }) {
  const { tokens } = useContext(AuthContext);
  const apiBase = process.env.REACT_APP_PORTAL_API_URL || '';
  const [role, setRole] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && user) {
      setRole(user.role || '');
      setError('');
      setSaving(false);
    }
  }, [open, user]);

  const handleSave = async () => {
    if (!role) {
      setError('Role is required');
      return;
    }
    setError('');
    try {
      setSaving(true);
      const res = await fetch(
        `${apiBase}/organizations/${organizationId}/users/${user.role_at_org_id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokens?.id_token}`,
          },
          body: JSON.stringify({ role }),
        }
      );
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || 'Failed to update role');
      }
      if (onUpdated) onUpdated({ ...user, role });
      onClose();
    } catch (e) {
      setError(e.message || 'Failed to update role');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit User Role</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Change the role for {user?.name || user?.email} at this organization.
        </Typography>
        <FormControl fullWidth size="small">
          <InputLabel id="edit-role-label">Role</InputLabel>
          <Select
            labelId="edit-role-label"
            value={role}
            label="Role"
            onChange={(e) => setRole(e.target.value)}
          >
            <MenuItem value="Provider">Provider</MenuItem>
            <MenuItem value="OfficeStaff">OfficeStaff</MenuItem>
          </Select>
        </FormControl>
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}

